module.exports = __webpack_public_path__ + "img/tc_bg.06f8e9f2.png";